const initialState = {
  index: [],
  data: {},
};

const Prospect = (state = initialState, action) => {
  switch (action.type) {
    case "CONTENT_TASK_INDEX":
      return { ...state, index: action.payload.index };
    case "CONTENT_TASK_DATA":
      return { ...state, data: action.payload.data };
    case "CONTENT_TASK_RESET":
      return initialState;
    default:
      return state;
  }
};

export default Prospect;
